<template>
  <van-button
    round
    :native-type="nativeType"
    :icon="icon"
    class="button"
    :class="`style${type}`"
    :disabled="disabled"
    @click="buttonCustomClick"
  >
    {{ text }}
  </van-button>

</template>
<script>
export default {
  name: 'CustomButton',
  components: {},
  props: {
  // 文本
    icon: {
      type: String,
      default: '',
    },
    nativeType: {
      type: String,
      default: 'button',
    },
    
    text: {
      type: String,
      default: "按钮",
      required: true,
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: [String, Number],
      default: 1,
      validator: function (val) {
        const v = +val || 1;
        const flag = [1, 2].includes(v);
        if (!flag) {
          console.error("按钮type可选值[1,2]");
        }
        return flag;
      },
    },
  },
  data() {
    return {

    }
  },

  created() {

  },

  methods: {
   buttonCustomClick() {
    this.$emit("click");
  }
  },
}
</script>

<style lang="less" scoped>
  .button {
    width: 100%;
    height: 45px;
    border-radius: 23px;
    border: 0;
    font-size: 14px;

    &.style1 {
      color: #ffffff;
      background: linear-gradient(147deg, #2da2ff 0%, #1469ff 100%);
      box-shadow: 0px 3px 5px 0px rgba(136, 187, 255, 0.5);
    }

    &.style2 {
      color: #007ff0;
      background: #ffffff;
      box-shadow: 0px 1px 6px 0px rgba(238, 241, 252, 1);
    }
  }

  /deep/.style1.van-button--disabled {
    background: #e1e1e1 !important;
    box-shadow: none !important;
    opacity: 1 !important;
  }
</style>
